import type { PropsWithChildren } from 'react';

import * as S from './Name.styles';

export const Name = ({
  children,
  className,
}: PropsWithChildren & {
  className?: string;
}) => {
  return (
    <S.NameContainer>
      <S.Name className={className} data-test-id='Name'>
        {children}
      </S.Name>
    </S.NameContainer>
  );
};

Name.displayName = 'Name';
